export default __webpack_public_path__ + "images/master-of-numbers.svg";